// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-popup-setting {
  /* display: none; Hidden by default */
  display: block;
  /* Hidden by default */
  position: absolute;
  /* Stay in place */

  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: hidden;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);

  /* Black w/ opacity */
}

.dialog-popup-setting.not-modal {
  background-color: unset;
  /* position: unset; */
  pointer-events: none;
}
/* Modal Content */
.dialog-content-popup {
  font-size: 14px;
  position: absolute;
  pointer-events: auto;
  /* top: 50%; */
  /* left: 50%; */
  
  background-color: var(--background-color-1);
  /* margin: auto; */
  padding: 0;
 color:var(--color-text-1) ;
  width: 400px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  user-select: none;
  border-radius: 4px;
}

/* The Close Button */
.dialog-close {
  font-size: 16px;
  font-weight: bold;
  color: var(--color-icon-1);
  cursor: pointer;
}

.dialog-header {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-color-1);
}

.dialog-header.with-cursor {
  cursor: all-scroll;
}

.dialog-body {
  height: calc(100% - 55px);
  overflow: auto;
}
.dialog-footer {

  padding: 0px 5px 0px 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--border-color-1);
}

.dialog-resize {
  height: 12px;
  width: 12px;
  float: right;
  cursor: nw-resize;
  margin: 0px 2px 2px 0;
}
.dialog-resize svg {
  fill: var(--color-icon-1);
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dialog/dialog.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;;EAElB,wBAAwB;EACxB,OAAO;EACP,MAAM;EACN,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;;EAEpC,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;AACtB;AACA,kBAAkB;AAClB;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;;EAEf,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;CACX,0BAA0B;EACzB,YAAY;EACZ,4EAA4E;EAC5E,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".dialog-popup-setting {\n  /* display: none; Hidden by default */\n  display: block;\n  /* Hidden by default */\n  position: absolute;\n  /* Stay in place */\n\n  /* Location of the box */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: hidden;\n  /* Enable scroll if needed */\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n\n  /* Black w/ opacity */\n}\n\n.dialog-popup-setting.not-modal {\n  background-color: unset;\n  /* position: unset; */\n  pointer-events: none;\n}\n/* Modal Content */\n.dialog-content-popup {\n  font-size: 14px;\n  position: absolute;\n  pointer-events: auto;\n  /* top: 50%; */\n  /* left: 50%; */\n  \n  background-color: var(--background-color-1);\n  /* margin: auto; */\n  padding: 0;\n color:var(--color-text-1) ;\n  width: 400px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  user-select: none;\n  border-radius: 4px;\n}\n\n/* The Close Button */\n.dialog-close {\n  font-size: 16px;\n  font-weight: bold;\n  color: var(--color-icon-1);\n  cursor: pointer;\n}\n\n.dialog-header {\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--border-color-1);\n}\n\n.dialog-header.with-cursor {\n  cursor: all-scroll;\n}\n\n.dialog-body {\n  height: calc(100% - 55px);\n  overflow: auto;\n}\n.dialog-footer {\n\n  padding: 0px 5px 0px 5px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid var(--border-color-1);\n}\n\n.dialog-resize {\n  height: 12px;\n  width: 12px;\n  float: right;\n  cursor: nw-resize;\n  margin: 0px 2px 2px 0;\n}\n.dialog-resize svg {\n  fill: var(--color-icon-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
